import React from 'react';
import { StyledProgressBar, StyledProgressBarFill } from './ProgressBar.styled';
export var ProgressBar = function (props) {
    var percent = props.percent, color = props.color;
    return (React.createElement(StyledProgressBar, null,
        React.createElement(StyledProgressBarFill, { percent: percent, color: color })));
};
//# sourceMappingURL=ProgressBar.js.map